module.exports = __webpack_public_path__ + "img/94.bd3fa89b.webp";